import { ReactNode } from 'react';
import { Controller, useFormContext, FieldPath, FieldValues, get } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SignatureCanvas from '@/components/ui/SignatureCanvas/SignatureCanvas';
import { useOpenFundFieldTracking } from '../OpenFundAnalyticsContext';
import styles from './SignaturePadField.module.scss';
import fieldStyles from './FormField.module.scss';

interface SignaturePadFieldProps<T extends FieldValues> {
  name: FieldPath<T>;
  label: string;
}

export function SignaturePadField<T extends FieldValues>({
  name,
  label,
}: SignaturePadFieldProps<T>) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();
  const trackField = useOpenFundFieldTracking();
  const error = get(errors, name);
  const fieldName = String(name);

  return (
    <div className={fieldStyles.fieldWrapper}>
      <label className={`body-sm-regular ${fieldStyles.label}`}>{label}</label>
      <span className={`body-sm-regular ${styles.instruction}`}>
        {t('openFundRequest.fields.signatureInstruction')}
      </span>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <SignatureCanvas
            invalid={!!error}
            onCapture={(base64Png) => {
              trackField(fieldName);
              field.onChange(base64Png);
            }}
          />
        )}
      />
      {error && (
        <span className={`body-sm-regular ${fieldStyles.errorMessage}`}>
          {error.message as ReactNode}
        </span>
      )}
    </div>
  );
}

export default SignaturePadField;
